import {
  Box,
  Container,
  Header,
  Table,
} from '@cloudscape-design/components';
import { useFormikContext } from 'formik';
import React, { useMemo } from 'react';
import { formatCurrency } from 'utils';

import {
  getEstimatePreviewRows,
  getEstimateTotal,
} from '../estimatePreview';

const columnDefinitions = [
  {
    id: 'productOrService',
    header: 'Product or service',
    cell: (item) => <strong>{item.productOrService}</strong>,
  },
  {
    id: 'description',
    header: 'Description',
    cell: (item) => item.description,
  },
  {
    id: 'quantity',
    header: 'Qty',
    cell: (item) => item.quantity || '',
  },
  {
    id: 'rate',
    header: 'Rate',
    cell: (item) => formatCurrency(item.rate),
  },
  {
    id: 'amount',
    header: 'Amount',
    cell: (item) => formatCurrency(item.amount),
  },
];

export default function EstimatePreviewTable() {
  const { values } = useFormikContext();
  const rows = useMemo(() => getEstimatePreviewRows(values), [values]);
  const total = useMemo(() => getEstimateTotal(values), [values]);

  return (
    <Container header={<Header variant="h2">Estimate Table Preview</Header>}>
      <Table
        variant="embedded"
        items={rows}
        trackBy="id"
        columnDefinitions={columnDefinitions}
        footer={(
          <Box textAlign="right" fontSize="heading-m" fontWeight="bold">
            {`Total ${formatCurrency(total)}`}
          </Box>
        )}
      />
    </Container>
  );
}
